import React from 'react';
import { Loader, Card } from 'semantic-ui-react';
import { bool, arrayOf, shape } from 'prop-types';

import GenreItem from './GenreItem';

const Genres = ({ loadingGenres, genres }) =>
  loadingGenres ? (
    <Loader active>Loading...</Loader>
  ) : (
    <Card.Group className="main-feed" centered>
      {genres.map(genre => (
        <GenreItem key={genre.name} genre={genre} />
      ))}
    </Card.Group>
  );

Genres.propTypes = {
  loadingGenres: bool.isRequired,
  genres: arrayOf(shape()).isRequired
};

export default Genres;
